module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-783eabc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-flickity/flickity.vue
// module id = 141
// module chunks = 1